@if (!hideAll) { @if (!inviteMode) {
<app-dialog-mode-switcher
  *onlyForScreens="['desktop', 'tablet']"
  location="share-gallery-dialog"
  [modes]="menuItems"
  [(mode)]="mode"
></app-dialog-mode-switcher>
} @if (inviteMode === 'email') {
<button
  (click)="collaborators.cancelInvite()"
  color="simple-gray"
  appButton
  name="cancel-invite"
  location="share-gallery-dialog"
  shape="round"
  [iconButton]="true"
  spacing="1"
  data-test-id="close-dialog-button"
  height="1"
  class="close-button"
>
  <app-svg src="/assets/icons/cross.svg"></app-svg>
</button>
} @if (inviteMode === 'choice') {
<button
  (click)="collaborators.cancelInviteChoice()"
  color="simple-gray"
  appButton
  name="cancel-invite-choice"
  location="share-gallery-dialog"
  shape="round"
  [iconButton]="true"
  spacing="1"
  data-test-id="close-dialog-button"
  height="1"
  class="close-button"
>
  <app-svg src="/assets/icons/cross.svg"></app-svg>
</button>
}
<div class="main-container">
  @if (mode === 'collaborators') {
  <app-share-gallery-collaborators
    [gallery]="gallery"
    #collaborators
    (onChangeInviteMode)="inviteMode = $event"
  ></app-share-gallery-collaborators>
  } @if (mode === 'link') {
  <app-share-gallery-link [gallery]="gallery"></app-share-gallery-link>
  } @if (mode === 'embed') {
  <app-share-gallery-embed [gallery]="gallery" (onChangeMode)="mode = $event"> </app-share-gallery-embed>
  }
</div>
<app-sticky-footer [items]="menuItems" (onItemClick)="mode = $event.key" [selected]="mode" *onlyForScreens="['mobile']">
</app-sticky-footer>
}
